import {triggerEvent} from '../utils/tracking';

const $ = window.jQuery;

/**
 * Enables 'AdvancedForms' plugin specific scripting
 */
const AdvancedForms = {

    /**
     * Initialise functionality
     */
    init()
    {

        $(function() {
            if (typeof acf === 'undefined') {
                return;
            }
            acf.addAction('af/form/setup', this.trigger_submit_event);
        });

    },

    /**
     * Trigger GA4 event on form submit
     *
     * @param {array} form AF form instance
     * @return void
     */
    trigger_submit_event(form)
    {

        // Try to run when it's fair to say the form will be submitting successfully
        // NOTE: priority 90 is just before AF's own AJAX submission step at 100
        af.addSubmissionStep(form, 90, function(callback) {

            // Retrieve form id and title from hidden fields
            const $formEl = form.$el;
            const formID = $formEl.find('input[type="hidden"][name="af_form_id"]').
            val() || '';
            const formTitle = $formEl.find(
                'input[type="hidden"][name="af_form_title"]').val() || '';

            // Skip if neither value was retrieved
            if (!formID && !formTitle) {
                callback();
                return;
            }

            // Build event data
            let eventData = {
                event: 'form_submit',
                form_id: formID,
                form_title: formTitle,
            };

            // Apply extra data (if requested)
            const $trackFieldEls = $formEl.find('input[type="hidden"][name="track"]');
            if ($trackFieldEls.length > 0) {
                $trackFieldEls.each(function() {
                    const fieldName = $(this).val();
                    const $fieldEl = $formEl.find(`.af-field[data-name="${fieldName}"]`);
                    const fieldKey = $fieldEl.data('key') || '';
                    const $fieldInput = $fieldEl.find(
                        `input[name="acf[${fieldKey}]"], select[name="acf[${fieldKey}]"], textarea[name="acf[${fieldKey}]"]`);
                    const fieldVal = $fieldInput.val();
                    if (fieldVal === undefined) {
                        return;
                    }
                    eventData[`form_val_${fieldName}`] = fieldVal;
                });
            }

            // Trigger GA4 event
            triggerEvent(eventData);

            // Indicate submission step completion for processing
            callback();

        });

    },

};

export default AdvancedForms;